<div class="detail-kpi-card" [attr.data-testid]="'detail-kpi-' + card.id">
    <div class="detail-kpi-label">{{ card.label }}</div>
    <div class="detail-kpi-value">
        <ng-container *ngIf="card.link as link; else plainValue">
            <a *ngIf="link.routerLink as rl; else clickOnly"
               [routerLink]="rl"
               class="detail-kpi-link"
               [attr.data-testid]="link.testId || null">
                {{ card.value }}
                <i class="fa fa-external-link-alt detail-kpi-link-icon"></i>
            </a>
            <ng-template #clickOnly>
                <a href="javascript:void(0)"
                   class="detail-kpi-link"
                   [attr.data-testid]="link.testId || null"
                   (click)="onLink()">
                    {{ card.value }}
                </a>
            </ng-template>
        </ng-container>
        <ng-template #plainValue>{{ card.value }}</ng-template>
    </div>
    <div *ngIf="card.sub" [class]="subClass(card.subTone)">{{ card.sub }}</div>
</div>
